import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { nullsafe } from "keautils";

type Entity = models.ClienteViewDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre, view: () => <p>{x.Nombre}</p> }) },
    { title: "Teléfono", cell: x => ({ data: x.Telefono }) },

    { title: "Acepta flete por cobrar", cell: x => ({ data: x.AceptaFletePorCobrar }) },
    { title: "Tarifa", cell: x => ({ data: x.NombreTarifa, view: () => <kea.Link children={x.NombreTarifa} tooltip={x.NombreTarifa} onClick={() => history.go("/catalogos/Tarifa/" + x.IdTarifa)} /> }) },
    { title: "Vendedor", cell: x => ({ data: x.NombreVendedor }) },
    { title: "Direccion de facturación", cell: x => ({ data: x.DireccionFacturacion }) },

    { title: "Tipo persona", cell: cli => ({ data: nullsafe(cli.TipoPersona, x => models.TipoPersona[x]) }) },
    { title: "Limite de credito", cell: x => ({ data: x.LimiteCredito, view: kea.formatCurrency }) },

    { title: "Cargos de crédito", cell: x => ({ data: x.CargoCredito, view: kea.formatCurrency }) },
    { title: "Abonos de crédito", cell: x => ({ data: x.AbonoCredito, view: kea.formatCurrency }) },
    { title: "Saldo de crédito", cell: x => ({ data: x.SaldoCredito, view: kea.formatCurrency }) },

    { title: "Dia de cobranza", cell: x => ({ data: models.DiaSemana[x.DiaCobranza] }) },
    { title: "Dia de revisión", cell: x => ({ data: models.DiaSemana[x.DiaRevision] }) },
    { title: "Sucursal de cobranza", cell: x => ({ data: x.IataSucursalCobranza }) },

];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>): Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/list/columns.tsx